import { Sandpack } from "@codesandbox/sandpack-react";

const PaginationApi = () => {
  const code = `import React from "react";
import { ReactUtilityTable } from "react-utility-table";

export default function App() {
  const [stopScroll, setStopScroll] = React.useState(false);
  const [mockData, setMockData] = React.useState([]);
  const pageRef = React.useRef(1); // Track current page

  React.useEffect(() => {
    apiCall(pageRef.current, 6);
  }, []);

  const apiCall = async (page, pageSize) => {
    try {
      const url = \`https://randomuser.me/api/?results=\${pageSize}&page=\${page}\`;
      const response = await fetch(url);
      const result = await response.json();

      if (page >= 2) {
        setStopScroll(true);
      }

      setMockData(prevData => [...prevData, ...result.results]);
    } catch (error) {
      console.error("Error fetching paginated data:", error);
    }
  };

  return (
    <div>
      <ReactUtilityTable
        data={mockData}
        columns={[
          {
            title: "Name",
            render: rowData => \`\${rowData.name.first} \${rowData.name.last}\`,
          },
          {
            title: "Email",
            field: "email",
          },
          {
            title: "Avatar",
            render: rowData => (
              <img
                style={{ height: 36, borderRadius: '50%' }}
                src={rowData.picture.thumbnail}
                alt="avatar"
              />
            ),
          }
        ]}
        options={{
        // Note paging should be always false when onScrollFetch is called
          paging: false,
        // always give  height for scroll effect
          maxBodyHeight: '18rem',
          showSerialNo: true,
          // scollStopTextStyle: {
          //     backgroundColor: '#01579b',
          //     color: '#FFF'
          //   },
        }}
        // stopScrollFetch Must have boolean value for stoping scroll
        stopScrollFetch={stopScroll}
        //  stopScrollFetchText={<button>Reach End</button>} 
        stopScrollFetchText="You Reached to Bottom"
        onScrollFetch={(oldData) =>
          new Promise((resolve) => {
            setTimeout(() => {
              pageRef.current += 1;
              apiCall(pageRef.current, 6);
              resolve();
            }, 3000);
          })
        }
      />
    </div>
  );
}`;

  return (
    <div>
      <p style={{ margin: "5px 0px" }}>
        <strong>PlayGround for editable: </strong>
        <br />
        <br />
      </p>

      <Sandpack
        template="react"
        files={{
          "/App.js": code,
        }}
        customSetup={{
          dependencies: {
            react: "18.0.0",
            "react-dom": "18.0.0",
            "react-scripts": "5.0.1",
            "react-utility-table": "2.1.5",
          },
        }}
        theme="dark"
        options={{
          showLineNumbers: true,
          editorHeight: 500,
        }}
      />
    </div>
  );
};

export default PaginationApi;
